import {
  hitRate,
  type AreaScore,
  type GroupScore,
} from '../../domain/entities/area-breakdown';

/**
 * Uma linha do quadro: nome, "X de Y · P%" e a barra de acerto. Os números
 * estão no texto; a barra só desenha o mesmo percentual, por isso sai do
 * leitor de tela.
 */
function ScoreRow({ group }: { group: GroupScore }) {
  const rate = hitRate(group);
  return (
    <>
      <div className="meter-head">
        <span className="meter-label">{group.name}</span>
        <span className="meter-value">
          {group.correct} de {group.total}
          <span className="meter-percent">{rate}%</span>
        </span>
      </div>
      <div className="meter" aria-hidden="true">
        <span className="meter-part is-acerto" style={{ width: `${rate}%` }} />
      </div>
    </>
  );
}

/**
 * **Acertos por grande área** (H1 da classificação), cada uma com as suas
 * subáreas (H2) num item que abre. Da área mais cobrada para a menos.
 *
 * Não aparece quando as questões não têm classificação (`areas` vazio).
 */
export function AreaBreakdown({ areas }: { areas: readonly AreaScore[] }) {
  if (areas.length === 0) return null;

  return (
    <section className="card area-breakdown">
      <h3>Acertos por grande área</h3>
      <p className="area-breakdown-note">
        Anuladas e questões sem resposta divulgada ficam fora; em branco conta
        como erro. Abra uma área para ver as subáreas.
      </p>

      <ul className="area-list">
        {areas.map((area) => (
          <li key={area.name}>
            {area.subareas.length > 0 ? (
              <details className="area-item">
                <summary className="area-summary">
                  <ScoreRow group={area} />
                </summary>
                <ul
                  className="subarea-list"
                  aria-label={`Subáreas de ${area.name}`}
                >
                  {area.subareas.map((sub) => (
                    <li key={sub.name}>
                      <ScoreRow group={sub} />
                    </li>
                  ))}
                </ul>
              </details>
            ) : (
              <div className="area-item">
                <ScoreRow group={area} />
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
